import { HOTEL_DATEPICKER_ID, HOTEL_NUMBERPICKER_ID } from '../../domain/search/filters/filters.constants'
import { isATransactionalHotelAppId } from '../../domain/utils/geoentity'
import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectUIGeoentityActiveFilterId } from '../ui/ui.selectors'
import { selectCurrentGeoentityApplicationId, selectGeoentityState } from './geoentity.selectors'
import { filterTypeIsKnown } from '../../domain/search/filters/filters.utils'
import { selectIsGE, selectIsPE } from '../navigation/navigation.selectors'

export const selectGeoentityFilterParameters = createCustomSelector(
  selectGeoentityState,
  geoentity => geoentity?.filterParameters
)

export const selectGeoentitiesFilters = createCustomSelector(
  selectGeoentityState,
  selectGeoentityFilterParameters,
  (geoentity, filterParameters) =>
    (geoentity?.filters ?? [])
      .filter(({ type }) => filterTypeIsKnown(type))
      .map(filter => ({
        ...filter,
        parameterValues: filterParameters?.[filter.id]
      }))
)

export const selectGeoentitiesPrimaryFilters = createCustomSelector(selectGeoentitiesFilters, filters =>
  filters.filter(({ primary }) => primary)
)

export const selectGeoentitiesHasSecondaryFilters = createCustomSelector(selectGeoentitiesFilters, filters =>
  filters.some(({ primary }) => !primary)
)

export const selectShouldDisplayAllFiltersOnPE = createCustomSelector(
  selectIsPE,
  selectGeoentitiesHasSecondaryFilters,
  (isPE, hasSecondaries) => isPE && hasSecondaries
)

export const selectShouldDisplayFilterFeaturesButtonsOnGE = createCustomSelector(
  selectIsGE,
  selectGeoentitiesHasSecondaryFilters,
  (isGE, hasSecondaries) => isGE && hasSecondaries
)

export const selectFiltersWithParametersCount = createCustomSelector(
  selectGeoentitiesFilters,
  filters => filters.filter(({ parameterValues }) => parameterValues).length
)

export const selectShouldDisplayFilters = createCustomSelector(selectGeoentitiesFilters, filters => filters.length > 0)

export const selectGeoentityActiveFilter = createCustomSelector(
  selectGeoentitiesFilters,
  selectUIGeoentityActiveFilterId,
  (filters, activeId) => activeId && filters.find(({ id }) => id === activeId)
)

export const selectHasFilterMultiDatePicker = createCustomSelector(selectGeoentitiesFilters, filters =>
  Boolean(filters.find(({ id }) => id === HOTEL_DATEPICKER_ID))
)

export const selectGeoentityActiveFilterParameter = createCustomSelector(
  selectGeoentityFilterParameters,
  selectUIGeoentityActiveFilterId,
  (filterParameters, filterId) => filterParameters && filterParameters[filterId]
)

export const selectIsTransactionalHotelGeoentity = createCustomSelector(
  selectCurrentGeoentityApplicationId,
  isATransactionalHotelAppId
)

export const selectFilterHotelDates = createCustomSelector(
  selectGeoentityFilterParameters,
  filterParameters => filterParameters && filterParameters[HOTEL_DATEPICKER_ID]
)

export const selectFilterHotelPeople = createCustomSelector(
  selectGeoentityFilterParameters,
  filterParameters => filterParameters && filterParameters[HOTEL_NUMBERPICKER_ID]
)
